export default __webpack_public_path__ + "static/media/Rotary-Club-Cordoba.b7e08d0a.jpg";